/**
 * ThemeToggleButton Component
 * Button to toggle dark/light theme
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Sun, Moon } from 'lucide-react';

export const ThemeToggleButton = ({ isDark, toggleTheme }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={toggleTheme}
    className="text-zinc-400 hover:text-white p-2"
    data-testid="theme-toggle"
    title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
  >
    {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
  </Button>
);

export default ThemeToggleButton;
